<template>
  <a-card title="用户管理">
    <a-space >
      <a-form layout="inline" :model="formSearch" style="margin: 10px auto;" >
        <a-form-item>
          <a-input placeholder="ID" v-model:value="formSearch.user_id" />
        </a-form-item>
        <a-form-item>
          <a-input placeholder="昵称" v-model:value="formSearch.nickname" />
        </a-form-item>
        <a-form-item>
          <a-input placeholder="外显ID" v-model:value="formSearch.outer_id" />
        </a-form-item>
        <a-form-item>
          <a-input placeholder="地区" v-model:value="formSearch.region_code" />
        </a-form-item>
        <a-form-item>
          <a-input placeholder="UUID" v-model:value="formSearch.uuid" />
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            @click="handleTableChange()"
            shape="circle"
          >
          <template #icon><SearchOutlined /></template>
          </a-button>
        </a-form-item>
      </a-form>
    </a-space>
    <a-alert :message="noticeMessage" type="info" show-icon style="text-align: left;"  />
      <a-table 
      class="ant-table-striped"
      :row-key="record => record.id"
      :data-source="dataSource" 
      :columns="columns" 
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
      >
      <template #expandedRowRender="{ record }">
        <a-table
          :data-source="Object.entries(record).map(([key, value]) => ({ key, value: typeof value === 'object' ? JSON.stringify(value, null, 2) : String(value) }))"
          :columns="[
            { title: '字段', dataIndex: 'key', key: 'key', width: 200 },
            { title: '值', dataIndex: 'value', key: 'value' }
          ]"
          :pagination="false"
          size="small"
          bordered
        />
      </template>
        <template #id="{ record }">
          <a :href="'http://admin.xuantu.pro/home/creation/works?user_id='+record.id">{{ record.id }}</a>
        </template>
        <template #nickname="{ record }">
          <span>{{ record.nickname ? record.nickname : '-' }}</span>
           <p>
            ({{ record.outer_id }})
          </p>
        </template>
        <template #first_task="{ record }">
         <div v-if="record.task_id > 0">
            <a :href="`/home/creation/works?task_id=` + record.task_id">{{ record.creation_kind }} {{ record.style_name }}</a>
          <div>{{ TaskStatus[record.task_status] }} ({{ record.reason }})</div>
         </div>
        </template>
        <template #information="{ record }">
          <img v-if="record.avatar" :src="record.avatar" width="100" height="100" />
          <div>
            地 区: {{ record.region_code }}
          </div>
          <div>
            操作系统: {{ record.os_platform }}
          </div>
          <div>
            货币: {{ record.store_currency || '-' }}
          </div>
           <div>
            游客:  <a-tag :color="record.is_guest ? 'red' : 'green'">{{ record.is_guest }}</a-tag>
          </div>
        </template>
        <template #phone="{ record }">
          <a-tooltip>
            <template #title>{{ record.country_code + record.phone }}</template>
            {{ record.phone ? "*******" + record.phone.substr(record.phone.length -4, 4) : '-' }}
          </a-tooltip>
        </template>
        <template #is_vip="{ record }">
          <a-tag v-if="record.is_vip" color="red">VIP</a-tag>
        </template>
        <template #action="{ record }">
          <a :href="`/home/user/profile?user_id=` + record.id">详细信息</a>
          <a-divider type="vertical" />
          <a :href="`/home/device/search?user_id=` + record.id">查看设备</a>
          <a-divider type="vertical" />
          <a-button danger @click="handleDeleteUser(record)">删除</a-button>
          <span class="delete-warning">谨慎操作</span>
        </template>
    
      </a-table>
  </a-card>

  <!-- <UserEditor v-model:visible="userEditorVisible" @cancle="userEditorVisible=false" /> -->

</template>
<script>
import { defineComponent,  onMounted} from 'vue'
// import UserEditor from '@/components/UserEditor.vue'
import { SearchOutlined } from '@ant-design/icons-vue';
import {useRoute} from 'vue-router'
import request from '@/utils/request'
import { Modal, message } from 'ant-design-vue';
import { useStore } from 'vuex'
const TaskStatus = {
  0: "排队中",
  1: "创作中",
  2: "创作完成",
  3: "创作失败",
}

export default defineComponent({
  components: {
    // UserEditor,
    SearchOutlined
  },
  data(){
    return {
      TaskStatus,
      loading: false,
      dataSource: [],
      pagination: {
        total: 1,
        current: 1,
        pageSize: 20,
        'show-size-changer': true,
        pageSizeOptions: ['20', '50', '100']
      },
      noticeMessage: '',

       formSearch: {
        user_id: '',
        nickname: '',
        mobile: '',
        region_code: '',
        uuid: '',
      },

      uploadLoading: false,
    }
  },
  mounted(){
    const route = useRoute()
    if (route.query['user_id']) {
      this.formSearch.user_id = route.query['user_id']
      this.handleTableChange()
    }
  },
  computed:{},
  methods: {
    async handleTableChange (pagi = {pageSize: 20, current: 1}) {
      this.loading = true
      const rsp = await request.get('/api/users/', {
        offset: (pagi.current - 1) * pagi.pageSize ,
        limit: pagi.pageSize,
        ...this.formSearch
      })
      this.loading = false
      const responseData = rsp.data || {}
      const list = Array.isArray(responseData.list) ? responseData.list : []
      const pagination = responseData.pagination || {}
      const total = pagination.total || 0
      this.dataSource = list
      this.noticeMessage = `共 ${total} 条`
      this.pagination.total = total
      this.pagination.current = pagi.current
      this.pagination.pageSize = pagi.pageSize
    },
    handleDeleteUser(record) {
      if (!String(record.phone || '').startsWith('1111055')) {
        message.warning('该账号不是测试账号，不可以删除')
        return
      }

      Modal.confirm({
        title: '确定要删除该测试账号，删除后不可恢复',
        okText: '确定',
        cancelText: '取消',
        onOk: async () => {
          await request.post(`/api/users/${record.id}/del`)
          message.success('删除成功')
          this.handleTableChange(this.pagination)
        },
      })
    },
  },
  setup(props, context) {
   
    return {
      uploadInput: null,
      columns: [
      {
          title: 'UID',
          dataIndex: 'id',
          key: 'id',
          slots: { customRender: 'id' },
        },
        {
          title: '用户昵称',
          dataIndex: 'nickname',
          key: 'nickname',
          slots: { customRender: 'nickname' },
        },
        {
          title: '信息',
          key: 'information',
          slots: { customRender: 'information' },
        },
        {
          title: '执行次数',
          dataIndex: 'creation_count',
          key: 'creation_count',
        },
        {
          title: '第一次任务',
          dataIndex: 'first_task',
          key: 'first_task',
          slots: { customRender: 'first_task' },
        },
        {
          title: '会员',
          dataIndex: 'is_vip',
          key: 'is_vip',
          slots: { customRender: 'is_vip' },
        },
        {
          title: '会员过期时间',
          dataIndex: 'vip_expired_at',
          key: 'vip_expired_at',
          // slots: { customRender: 'is_vip' },
        },
        {
          title: '注册时间',
          dataIndex: 'created_at',
          key: 'created_at',
        },
        {
          title: '操作',
          key: 'action',
          slots: { customRender: 'action' },
        },
        
       
      ],
    };
  },
})
</script>

<style scoped>
.ant-table-striped :deep(.table-striped) td {
  background-color: #fafafa;
}

.delete-warning {
  margin-left: 8px;
  color: #cf1322;
  font-weight: 500;
}
</style>
